import {injectableClass} from '../utils/Utils'
import {BaseTrade} from './BaseTrade'

@injectableClass("webtrader")
export class Trade extends BaseTrade {
  recalculateProfit() {
    this.profit = this.constructor.Quotes.convertCurrency(
      this.quote.profitFormula(this) / 100,
      this.quote.currency,
      this.constructor.Account.info.currency.slug
    )
    if (this.isSell)
      this.profit *= -1
    if (this.quote.short_symbol == "ETHXAG" || this.quote.short_symbol == "ETHXAU")
      this.profit /= 1000

  }
}
